var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.072,
    height: 17.909,
    viewBox: "0 0 151.072 17.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8722",
    "data-name": "\\uC0AC\\uAC01\\uD615 8722",
    width: 151.072,
    height: 17.909,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7569",
    "data-name": "\\uADF8\\uB8F9 7569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12532",
    "data-name": "\\uD328\\uC2A4 12532",
    d: "M9.77,1.75H4.385V5.567H9.443v.025L7.816,7.218H4.385V17.935H.016V11.526H0V2.465A2,2,0,0,1,1.225.684,5.147,5.147,0,0,1,3.741.1L11.4.086V.092L9.77,1.75",
    transform: "translate(0 -0.026)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12533",
    "data-name": "\\uD328\\uC2A4 12533",
    d: "M143.356,10.929v9.36H139.1l-.08-.975a4.092,4.092,0,0,1-1.145.637,3.707,3.707,0,0,1-1.322.338H132.28q-2.16,0-2.16-1.612V13.139q0-1.677,2.467-1.69l4.16-.026a6.838,6.838,0,0,1,2.144.936l.032-.117V9.591h-8.577l1.7-1.662,7.525.01c3.777,0,3.789,2.99,3.789,2.99m-4.466,6.929V13.907l-1.048-.781h-3.337v5.513h3.4Z",
    transform: "translate(-39.275 -2.393)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12534",
    "data-name": "\\uD328\\uC2A4 12534",
    d: "M29.451,10.929v9.36H25.194l-.08-.975a4.091,4.091,0,0,1-1.145.637,3.707,3.707,0,0,1-1.322.338H18.375q-2.16,0-2.16-1.612V13.139q0-1.677,2.467-1.69l4.16-.026a6.851,6.851,0,0,1,2.144.936l.032-.117V9.591H16.441c.66-.646,1.035-1.015,1.7-1.662l7.525.01c3.777,0,3.789,2.99,3.789,2.99m-4.466,6.929V13.907l-1.048-.781H20.6v5.513H24Z",
    transform: "translate(-4.894 -2.393)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12535",
    "data-name": "\\uD328\\uC2A4 12535",
    d: "M189.978,18.643h-8.2V14.625h8.852V9.5a1.421,1.421,0,0,0-.387-1.17,3.937,3.937,0,0,0-2.145-.39h-8.4a3.3,3.3,0,0,0-1.967.39,1.518,1.518,0,0,0-.338,1.17v9.672a1.018,1.018,0,0,0,.258.832,3.377,3.377,0,0,0,1.741.286h10.586Zm-8.2-9.022h4.385v3.224h-4.385Z",
    transform: "translate(-53.544 -2.398)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12536",
    "data-name": "\\uD328\\uC2A4 12536",
    d: "M119.446,18.643h-8.2V14.625H120.1V9.5a1.421,1.421,0,0,0-.387-1.17,3.939,3.939,0,0,0-2.145-.39h-8.4a3.3,3.3,0,0,0-1.967.39,1.518,1.518,0,0,0-.338,1.17v9.672a1.018,1.018,0,0,0,.258.832,3.375,3.375,0,0,0,1.741.286h10.586Zm-8.2-9.022h4.385v3.224h-4.385Z",
    transform: "translate(-32.255 -2.398)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12537",
    "data-name": "\\uD328\\uC2A4 12537",
    d: "M88.886.026,80.017,15.845l-1.49-5.087L84.284.026H78.512L68.854,17.8l-.01-.033L67.36,12.824,74.286.109,68.474.134,64.163,8.071l2.954,9.846h.889l.759,0,5.8-.016,2.95-5.333,1.591,5.214.016.138h5.795L94.656.026Z",
    transform: "translate(-19.367 -0.008)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12538",
    "data-name": "\\uD328\\uC2A4 12538",
    d: "M207.173,7.944l-1.786,1.338,0-1.338h-4.368v12.35H205.4l-.013-9.235,1.784-1.337h2.8l1.773-1.773v0Z",
    transform: "translate(-60.675 -2.398)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12539",
    "data-name": "\\uD328\\uC2A4 12539",
    d: "M52.811,6.019A2.765,2.765,0,0,0,50.836,5.5H44.345V0H39.861V17.9h4.354l.129-1.058A2.437,2.437,0,0,0,46.692,17.9h4.451a2.111,2.111,0,0,0,1.748-.575,1.994,1.994,0,0,0,.259-1.174V7.194a1.663,1.663,0,0,0-.339-1.175m-4.063,10.22H45.332l-.988-.914V7.181h4.4Z",
    transform: "translate(-12.032 0)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12540",
    "data-name": "\\uD328\\uC2A4 12540",
    d: "M162.577,7.944v8.242l-1.889,1.768h-.647l-1.889-1.768V7.944h-4.385v7.982l4.821,4.368h3.553l4.821-4.368V7.944Z",
    transform: "translate(-46.413 -2.398)",
    fill: "#1d252c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c200a3486dd7715e947a07e8a1af7501.svg";
export { ForwardRef as ReactComponent };